"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";

// App Router nawiguje klientowo (model SPA) — GTM/Pixel domyślnie liczą tylko
// pierwszy page-view. Pushujemy zdarzenie page_view do dataLayer przy każdej
// zmianie trasy, aby odwzorować śledzenie odsłon z poprzedniej aplikacji.
// Musi być wewnątrz <Suspense> (useSearchParams) — patrz app/layout.tsx.
export function NavigationTracking() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (typeof window === "undefined") return;
    const w = window as typeof window & {
      dataLayer?: Record<string, unknown>[];
    };
    w.dataLayer = w.dataLayer || [];
    const query = searchParams.toString();
    w.dataLayer.push({
      event: "page_view",
      page_path: query ? `${pathname}?${query}` : pathname,
    });
  }, [pathname, searchParams]);

  return null;
}
